import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function WhatYouLearn() {
  const learnings = ['Entender el embarazo sin sentirte abrumada', 'Prepararte emocionalmente para el parto', 'Reconocer qué es normal en un recién nacido', 'Entender el llanto, el sueño y la alimentación', 'Saber cuándo consultar y cuándo no preocuparte', 'Recuperar confianza en vos misma como mamá'];
  return <section className="py-20 md:py-28 bg-sage-light/20" data-id="element-333">
      <div className="max-w-5xl mx-auto px-6" data-id="element-334">
        <div className="text-center mb-16" data-id="element-335">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-336">
            🌸 QUÉ VAS A APRENDER
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-337">
            Herramientas reales para sentirte más tranquila y segura
          </h2>
          <p className="font-serif italic text-xl text-peach-dark" data-id="element-338">
            Cada capítulo está pensado para acompañarte paso a paso
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-339">
          {learnings.map((learning, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.08
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-sage-light flex items-start gap-4" data-id="element-340">
              <div className="w-10 h-10 rounded-full bg-sage-light flex items-center justify-center shrink-0" data-id="element-341">
                <Check className="w-5 h-5 text-sage" strokeWidth={2.5} data-id="element-342" />
              </div>
              <span className="text-text-dark font-medium pt-1.5" data-id="element-343">
                {learning}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}